import React, { useState, useEffect } from "react";
import "./Header.css";

const Header = () => {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'light';
    setTheme(savedTheme);
    document.documentElement.setAttribute('data-theme', savedTheme);
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
  };

  return (
    <div className="navbar">
      <h1 className="navbar-brand">
        Texify Elite
      </h1>
      <div className="navbar-links">
        <a className="navbar-link" target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/avijitd22/">
          LinkedIn
        </a>
        <a className="navbar-link" target="_blank" rel="noreferrer" href="https://avijitd22.vercel.app/">
          Portfolio
        </a>
        <button className="theme-toggle" onClick={toggleTheme} title="Toggle theme">
          {theme === 'light' ? '🌙' : '☀️'}
        </button>
      </div>
    </div>
  );
};

export default Header;
